import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { api } from '../Services/api';
import companyReducer from './companySlice'
import subscriptionReducer from './subscriptionSlice'

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    company: companyReducer,
    subscription: subscriptionReducer,
  },
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware().concat(api.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;